import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { LigacaoTelemarketing } from '../models/ligacao-telemarketing';

@Injectable({
  providedIn: 'root'
})
export class FilaTarefaService {

  constructor(private http: HttpClient) { }

  consultarLista(tipoFila, idFila, status, somenteAbertas, idFuncionario, pesquisa, tipoFiltro, inicio, fim, tipoOrdenacao, pag, qt, possuiProposta, pesquisaIntegradorProponente) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/ListarTarefas',
      {
        inicio: inicio !== null && inicio !== undefined && fim !== null && fim !== undefined ? inicio : null,
        fim: inicio !== null && inicio !== undefined && fim !== null && fim !== undefined ? fim : null,
        tipoFiltro: tipoFiltro !== null && tipoFiltro !== undefined ? tipoFiltro : 0,
        tipoFila: tipoFila !== null && tipoFila !== undefined ? tipoFila : null,
        idFila: idFila !== null && idFila !== undefined ? idFila : null,
        status: status !== null && status !== undefined ? status : null,
        somenteAbertas: somenteAbertas !== null && somenteAbertas !== undefined ? somenteAbertas : false,
        idFuncionario: idFuncionario !== null && idFuncionario !== undefined ? idFuncionario : null,
        pesquisa: pesquisa !== null && pesquisa !== undefined ? pesquisa : null,
        tipoOrdenacao: tipoOrdenacao !== null && tipoOrdenacao !== undefined ? tipoOrdenacao : null,
        pag: pag !== null && pag !== undefined ? pag : null,
        qt: qt !== null && qt !== undefined ? qt : null,
        possuiProposta: possuiProposta !== null && possuiProposta !== undefined ? possuiProposta : null,
        pesquisaIntegradorProponente: pesquisaIntegradorProponente !== null && pesquisaIntegradorProponente !== undefined ? pesquisaIntegradorProponente : null
      });
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FilaTarefa/BuscarTarefa',
      { params: new HttpParams().set('id', id.toString()) });
  }

  definirPrioridade(id, temPrioridade) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/DefinirPrioridade', {},
      { params: new HttpParams().set('id', id.toString()).set('temPrioridade', temPrioridade) });
  }

  vincularTarefaComFuncionario(tarefa, idFuncionario) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/VincularTarefaComFuncionario', tarefa,
      { params: new HttpParams().set('idFuncionario', idFuncionario.toString()) });
  }

  vincularTarefasSemFuncionario(idFila) {
    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/VincularTarefasSemFuncionario', {},
      { params: new HttpParams().set('idFila', idFila.toString()) });
  }

  alterarStatusTarefa(id, status, obs) {

    let parametros = new HttpParams().set('id', id).set('status', status);

    if (obs !== null && obs !== undefined){
      parametros = parametros.set('obs', obs);
    }

    return this.http.post<any>(globals.apiUrl + '/api/FilaTarefa/AlterarStatusTarefa', {},
      { params: parametros });
  }

  consultarLog(idTarefa: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FilaTarefa/BuscarLog',
      { params: new HttpParams().set('idTarefa', idTarefa.toString()) });
  }

  consultarTarefasDoPedido(idCupom, tipo) {
    return this.http.get<any>(globals.apiUrl + '/api/FilaTarefa/BuscarTarefasDoPedido',
      { params: new HttpParams().set('idCupom', idCupom).set('tipo', tipo) });
  }
}
